import { httpRequest } from 'http'

import { sendErrorNotification } from 'helpers/web_to_client'

export const CLAN_QUESTS_LOAD_REQUEST = 'clan_quests/REQUEST'
export const CLAN_QUESTS_LOAD_SUCCESS = 'clan_quests/SUCCESS'
export const CLAN_QUESTS_LOAD_ERROR = 'clan_quests/ERROR'

export function clanQuestsRequestStart() {
    return {
        type: CLAN_QUESTS_LOAD_REQUEST,
    }
}

export function clanQuestsRequestSuccess(data) {
    return {
        type: CLAN_QUESTS_LOAD_SUCCESS,
        payload: data,
    }
}

export function clanQuestsRequestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: CLAN_QUESTS_LOAD_ERROR,
        payload: errorData,
    }
}

export const REQUEST_INTERVAL = 5000
export function requestClanQuestsInfo() {
    return async (dispatch, getState) => {
        const state = getState()
        const requestNotPossibleByTimeout = state.clanQuests.lastRequestTimestamp &&
            (Date.now() - state.clanQuests.lastRequestTimestamp) < REQUEST_INTERVAL
        if (state.clanQuests.loading || requestNotPossibleByTimeout) {
            return
        }

        dispatch(clanQuestsRequestStart())

        httpRequest(`${window.config.WGCG_API_URL}/wgcq/wgcg/landing/get_landing_data/`)
        .then(
            data => {
                data.player_tasks.sort((a, b) => a.type.localeCompare(b.type))
                data.clan_tasks.sort((a, b) => a.type.localeCompare(b.type))
                dispatch(clanQuestsRequestSuccess(data))
            },
            errorData => {
                if (errorData.statusCode === 503) {
                    dispatch(clanQuestsRequestSuccess({ disabled: true }))
                } else {
                    dispatch(clanQuestsRequestError(errorData))
                }
            },
        )
    }
}



// WEBPACK FOOTER //
// ./state/actions/clanQuests.js